const columnsAllHoliday = [
  {
    title: "Index",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    align: "center",
    width: 50,
  },
  {
    title: "Year",
    key: "year",
    dataIndex: "year",
    align: "center",
    width: 80,
  },
  {
    title: "Type",
    key: "type",
    dataIndex: "type",
    width: 175,
  },
  {
    title: "Title",
    key: "name",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 250,
  },
  {
    title: "Start date",
    dataIndex: "startDate",
    key: "startDate",
    scopedSlots: { customRender: "startDate" },
  },
  {
    title: "End date",
    key: "endDate",
    dataIndex: "endDate",
    scopedSlots: { customRender: "endDate" },
  },
  {
    title: "Duration",
    key: "duration",
    dataIndex: "duration",
    align: "right",
  },
  // {
  //   title: "Tạo bởi",
  //   key: "author",
  //   scopedSlots: { customRender: "author" },
  // },
  {
    title: "Created At",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },
  // {
  //   title: "Updated At",
  //   key: "updatedAt",
  //   dataIndex: "updatedAt",
  //   scopedSlots: { customRender: "updatedAt" },
  // },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
  },
];

export { columnsAllHoliday };
